<template>
 <div>
  <b-row>
    <b-col md="1">
    </b-col>
    <b-col md="10">
      <b-card md="1" bg-variant="none"> {{description}}</b-card>
    </b-col>
    <b-col md="1">
    </b-col>
  </b-row>
  <br>
  <b-row>
    <b-col md="1">
    </b-col>
    <b-col md="10">
      <b-card bg-variant="light">
        <!-- <div v-if="showInterestSelection">
          <interest-dropdown @selectedItems="setInterestId" :filtering="interest_filtering"> </interest-dropdown>
        </div> -->
        <div v-if="showListingSelection">
          <product-listing-dropdown @selectedItems="setListingId" :filtering="product_listing_filtering"></product-listing-dropdown>
        </div>
        <div v-if="showStorageSpaceSelection">
          <storage-space-dropdown @selectedItems="setStorageSpaceId" :filtering="storage_space_filtering"></storage-space-dropdown>
        </div>
        <ValidationObserver ref="observer">
        <b-form slot-scope="{ validate }" @submit.prevent="validate().then(callApi)">
        <b-form-group
          label="Stage"
          v-slot="{ ariaDescribedby }"
        >
          <b-form-radio-group
            id="btn-radios-2"
            v-model="selected"
            :options="options"
            :aria-describedby="ariaDescribedby"
            button-variant="outline-primary"
            size="sm"
            name="radio-btn-outline"
            buttons
          ></b-form-radio-group>
        </b-form-group>
        <b-form-group 
          label-cols-lg="3"
          label="Asset"
          label-size="lg"
          label-class="font-weight-bold pt-0"
          class="mb-0"
        >

          <b-form-group
            label="Description:"
            label-for="nested-description"
            label-cols-sm="3"
            label-align-sm="right"
          >
            <b-form-input id="nested-description"
              v-model="attr_copy.description"
            ></b-form-input>
          </b-form-group>

        <b-form-group
            label="Serial / Copy #:"
            label-for="nested-serial-number"
            label-cols-sm="3"
            label-align-sm="right"
          >
            <b-form-input id="nested-serial-number" type="number"
              v-model="attr_copy['serial-number']"
            ></b-form-input>
          </b-form-group>
        
        <b-form-group
            label="Estimated Min Price :"
            label-for="nested-estimated-min-price"
            label-cols-sm="3"
            label-align-sm="right"
            v-show="selected === 'display_estimate'"
          >
            <b-input-group size="sm" prepend="$">
              <b-form-input-currency
                id="nested-estimated-min-price"
                v-model="attr_copy['estimated-min-price-cents']"
              ></b-form-input-currency>
            </b-input-group>
          </b-form-group>

          <b-form-group
            label="Estimated Max Price :"
            label-for="nested-estimated-max-price"
            label-cols-sm="3"
            label-align-sm="right"
            v-show="selected === 'display_estimate'"
          >
            <b-input-group size="sm" prepend="$">
              <b-form-input-currency
                id="nested-estimated-max-price"
                v-model="attr_copy['estimated-max-price-cents']"
              ></b-form-input-currency>
            </b-input-group>
          </b-form-group>

        <b-form-group
            label="Authenticated Min Price :"
            label-for="nested-authenticated-min-price"
            label-cols-sm="3"
            label-align-sm="right"
            v-show="selected === 'display_authorize'"
          >
            <b-input-group size="sm" prepend="$">
              <b-form-input-currency
                id="nested-authenticated-min-price"
                v-model="attr_copy['authenticated-min-price-cents']"
              ></b-form-input-currency>
            </b-input-group>
          </b-form-group>

        <b-form-group
            label="Authenticated Max Price :"
            label-for="nested-authenticated-max-price"
            label-cols-sm="3"
            label-align-sm="right"
            v-show="selected === 'display_authorize'"
          >
            <b-input-group size="sm" prepend="$">
              <b-form-input-currency
                id="nested-authenticated-max-price"
                v-model="attr_copy['authenticated-max-price-cents']"
              ></b-form-input-currency>
            </b-input-group>
          </b-form-group>

        <b-form-group
            label="Asking Price :"
            label-for="nested-asking-price"
            label-cols-sm="3"
            label-align-sm="right"
          >
            <b-input-group size="sm" prepend="$">
              <b-form-input-currency
                id="nested-asking-price"
                v-model="attr_copy['asking-price-cents']"
              ></b-form-input-currency>
            </b-input-group>
          </b-form-group>
        <b-form-group
            label="Estimated Quality :"
            label-for="nested-estimated-quality"
            label-cols-sm="3"
            label-align-sm="right"
            v-show="selected === 'display_estimate'"
          >
            <five-star-rating-update v-model="attr_copy['estimated-quality']">
            </five-star-rating-update>
        </b-form-group>

        <b-form-group
            label="Authenticated Quality :"
            label-for="nested-authenticated-quality"
            label-cols-sm="3"
            label-align-sm="right"
            v-show="selected === 'display_authorize'"
          >
            <b-input-group size="sm" prepend="%" :append="`${attr_copy['authenticated-quality']/100}`">
              <b-form-input
                id="nested-authenticated-quality"
                v-model="attr_copy['authenticated-quality']"
                type="range" min="0" max="10000"
              ></b-form-input>
            </b-input-group>
        </b-form-group>

        </b-form-group>
      </b-form>
      </ValidationObserver>
      <br>
      </b-card>
    </b-col>
    <b-col md="1">
      <data-operations
        :modified="modified"
        :can_update="canUpdate"
        :can_delete="canDelete"
        :can_help="canHelp"
        @update="doUpdate"
        @undo="doUndo"
        @delete="doDelete"
        @cancel="doCancel"
        @help="doHelp"
      ></data-operations>
    </b-col>
  </b-row>
 </div>
</template>

<script>
import {http_v1} from '@/axios'
import ProductListingDropdown from './ProductListingDropdown.vue'
import StorageSpaceDropdown from './StorageSpaceDropdown.vue'
// import InterestDropdown from './InterestDropdown.vue'
import {amsMofifiedAttrs} from '@/utils'
import {deepEqual} from '@/utils'
import {amsSchema} from '@/schema'
import DataOperations from './DataOperations.vue'
import { ValidationObserver } from 'vee-validate'
import BFormInputCurrency from './BFormInputCurrency.vue'
import FiveStarRatingUpdate from './FiveStarRatingUpdate.vue'


export default {
  components: {
    ProductListingDropdown,
    StorageSpaceDropdown,
    // InterestDropdown,
    ValidationObserver,
    DataOperations,
    BFormInputCurrency,
    FiveStarRatingUpdate
  },
  props: {
    reroute: {
      Type: Boolean,
      default: true
    },
    ams_template: {
      Type: Object
    },
  },
  data () {
    return {
      ams_type: 'product-items',
      ams_api_path: 'api/admin/v1/',
      modified: false,
      attr_copy: {},
      attr_orig: {},
      description: undefined,
      selected: 'display_estimate',
      options: [
        { text: 'Estimate', value: 'display_estimate' },
        { text: 'Authorize', value: 'display_authorize' /*, disabled: true */ },
      ],
      product_listing_filtering: {
        interest_ids: this.$store.getters['cached_products/interest_ids']
      },
      storage_space_filtering: {
        storage_accesses: ['access_enclosed', 'access_open']
      },
      // interest_filtering: {
      //   ids: this.$store.getters['cached_products/interest_ids']
      // }
    }
  },
  computed: {
    showListingSelection() {
      return !(this.attr_copy['product-listing-id']?.length > 0)
    },
    // showInterestSelection() {
    //   return false
    // },
    showStorageSpaceSelection() {
      return !(this.attr_copy['storage-space-id']?.length > 0 || this.attr_copy['storage-space-id'] > 0)
    },
    canUpdate() {
      return (
        this.attr_copy['product-listing-id']?.length > 0
        && (this.attr_copy['storage-space-id']?.length > 0 || this.attr_copy['storage-space-id'] > 0)
        && (this.attr_copy['serial-number']?.length > 0 || this.attr_copy['serial-number'] > 0)
      )
    },
    canDelete() {
      return false
    },
    canHelp() {
      return true
    }
  },
  methods: {
    doUpdate() {
      this.callApi()
    },
    doUndo() {
        this.attr_copy = Object.assign( {}, this.attr_orig)
    },
    doCancel() {
      this.$emit('noAction')
      if(this.reroute) {
        this.$router.go(-1)
      }
    },
    doDelete() {
    },
    doHelp() {
      http_v1.get(this.ams_api_path + 'features', {
        params: {
          title: this.ams_type
        }
      }).then(response => {
        if( response.data) {
          let feature = response.data.data[0]
          this.$router.push( {path: '/features' + '/' + feature.id + '/show'} )
        }
      }).catch(error => {
        if( error.response && error.response.data) {
          var message = error.response.data.message || JSON.stringify(error.response.data)
          if (error.response.status === 500 ) message = "500 Server Error"
          this.$bvToast.toast(message, {
            title: 'Error',
            autoHideDelay: 5000,
            appendToast: true
          })
        }
      })
    },
    // setInterestId(items) {
    //   this.product_listing_filtering.interest_ids = items[0].id
    // },
    setListingId(items) {
      this.attr_copy['product-listing-id'] = items[0].id
    },
    setStorageSpaceId(items) {
      this.attr_copy['storage-space-id'] = items[0].id
    },
    apiResourcePath() {
      return this.ams_api_path + this.ams_type.replace(/-/g, '_')
    },
    callApi () {
      let attr_params = amsMofifiedAttrs(this.attr_copy, this.attr_orig)
      http_v1.post (
        this.apiResourcePath(), {
          ...attr_params
        }
      ).then(response => {
        if( response.data) {
         this.$store.dispatch('cached_products/add_product', response.data.data).then(() => {
          }).catch(() => {
          })
          this.$emit('takeAction')
          if(this.reroute) {
            this.$router.go(-1)
          }
        }
      }).catch(error => {
        if( error.response && error.response.data) {
          var message = error.response.data.message || JSON.stringify(error.response.data)
          if (error.response.status === 500 ) message = "500 Server Error"
          this.$bvToast.toast(message, {
            title: 'Error',
            autoHideDelay: 5000,
            appendToast: true
          })
        }
      })
    },
    callCancel() {
      this.$emit('noAction')
      if(this.reroute) {
        this.$router.go(-1)
      }
    }
  },
  watch: {
     attr_copy : {
        handler() {
          if(deepEqual(this.attr_copy,this.attr_orig)) {
            this.modified = false
          }
          else {
            this.modified = true
          }
        },
        deep: true
     }
  },
  mounted() {
    if(this.ams_template?.attributes) {
      this.attr_copy = {...this.ams_template.attributes}
    }
    else {
      const included_obj = amsSchema.find( 
        el =>  
        el.type === this.ams_type
      )
      this.attr_copy = {...included_obj.attributes}
    }
    this.description = this.ams_template?.description
  }
}
</script>